import { finish, error } from '../../../modules/participants/actions/update-participant';
import api from '../../../api';

export function request(dispatch, action) {
    $appState.sdkStaff.createParticipant({requestBody: action.participant}).then(
        participant => {
            if (participant.status > 400) {
                dispatch(error(participant.errors));
            } else {
                dispatch(finish(action.sportId, participant));
            }
        },
        errors => {
            dispatch(error(errors));
        }
    );
}
